/* eslint-disable react/prop-types */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import { IoFunnel } from "react-icons/io5";

import { isEmpty, orderBy, find } from "lodash";
import moment from "moment";
import { Row, Col, FormGroup, DropdownButton, NavItem } from "react-bootstrap";
import Select from "react-select";
import JotformEmbed from "react-jotform-embed";

import Modal from "../common/Modal";

import * as supportTicketActions from "../../actions/supportTicketActions";
import * as callActions from "../../actions/callActions";
import * as codeActions from "../../actions/codeActions";
import * as userActions from "../../actions/userActions";
import * as departmentActions from "../../actions/departmentActions";
import * as customerActions from "../../actions/customerActions";
import * as modalActions from "../../actions/modalActions";
import * as contractActions from "../../actions/contractActions";
import * as projectActions from "../../actions/projectActions";

import { formatDate } from "../../helpers/date";

import HeaderWrapper from "../common/HeaderWrapper";

import SupportTicketList from "./SupportTicketList";
import Badge from "../common/Badge";
import Checkbox from "../common/Checkbox";
import SupportTicketBoard from "./SupportTicketBoard";
import FiltersComponent from "../common/FiltersComponent";
import ConfirmModal from "../common/ConfirmModal";
import SupportTicketForm from "./SupportTicketForm";
import SupportTicketDisplay from "./SupportTicketDisplay";
import { customToast as toast } from "../../utils";

const jotFormUrl = import.meta.env.VITE_JOTFORM_URL;
const jotFormKey = import.meta.env.VITE_JOTFORM_KEY;

class SupportTicketPage extends Component {
  // eslint-disable-next-line react/sort-comp
  onPageSizeChange = (pageSize) => {
    localStorage.setItem("DEFAULT_PAGE_SIZE_SUPPORT_TICKET_LIST", pageSize);
  };

  getCode = (label, entity) => {
    const { codes } = this.props;
    const status = codes.find((c) => c.label === label && c.entity === entity);
    return status?.id;
  };

  ticketMovementsAllowed = {
    0: [1], // Move from order = 0: can only move to order = 1.
    1: [2, 3], // Move from order = 1: can only move to order = 2 or 3.
    2: [1], // Move from order = 2: can only move to order = 1.
    3: [1, 2] // Move from order = 3: can only move to order = 1 or 2.
  };

  constructor(props) {
    super(props);
    this.state = {
      reload: false,
      open: true,
      view: 1,
      focusedInput: null,
      supportTickets: [],
      users: [...this.props.users],
      defaultPageSize: localStorage.getItem(
        "DEFAULT_PAGE_SIZE_SUPPORT_TICKET_LIST"
      )
        ? parseInt(
            localStorage.getItem("DEFAULT_PAGE_SIZE_SUPPORT_TICKET_LIST")
          )
        : 10,
      filters: localStorage.getItem("ticket-filters")
        ? JSON.parse(localStorage.getItem("ticket-filters"))
        : {
            request_status: [
              {
                value: this.getCode("In Process", "Support Ticket"),
                label: "In Process"
              }
            ],
            assigned_department: [],
            multi_assigned_to: [],
            customer: [],
            location: ""
          },
      viewDisplay: false,
      ticket: {},
      source: {},
      destination: {},
      lastCall: {},
      actionRequiredBy: "",
      supportTicketsBoard: [],
      sendCustomerEmail: true
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true });
    this.setState({
      viewDisplay: localStorage.getItem("tickets-view") === "true"
    });
    if (isEmpty(this.props.users)) await this.props.actions.loadUsers();
    if (isEmpty(this.props.customers)) await this.props.actions.loadCustomers();
    if (isEmpty(this.props.codes)) await this.props.actions.loadCodes();
    if (isEmpty(this.props.contracts)) {
      await this.props.actions.loadContracts();
    }
    if (isEmpty(this.props.projects)) {
      await this.props.actions.loadProjects();
    }

    const newSupportTicketsBoard = await orderBy(
      this.props.codes
        .filter(
          (code) => code.entity === "Support Ticket" && code.field === "status"
        )
        .map((code) => ({
          value: code._id,
          label: code.label,
          order: code.order,
          tickets: [],
          count: 0,
          pages: 0,
          page: 0
        })),
      [(option) => option.order],
      "order"
    );
    await this.props.actions.setSupportTicketsBoardReducer(
      newSupportTicketsBoard
    );

    this.setState(
      {
        users: this.props.users,
        customers: this.props.customers,
        codes: this.props.codes
      },
      () => {
        if (this.state.viewDisplay) this.getTicketsBoard();
      }
    );
    this.setState({ loading: false });
  };

  getTicketsBoard = async () => {
    try {
      this.setState({ loading: true });
      const { supportTicketsBoard, actions } = this.props;
      const newSupportTicketsBoard = await Promise.all(
        supportTicketsBoard.map(async (availableStatus) => {
          const { filters, defaultPageSize: pageSize } = this.state;
          const statusToGetData = filters.request_status.length
            ? filters.request_status.find(
                (rStatus) => rStatus.value === availableStatus.value
              )
            : availableStatus;
          let result =
            statusToGetData && availableStatus.tickets.length
              ? availableStatus
              : {
                  ...availableStatus,
                  tickets: [],
                  page: 0,
                  pages: 0,
                  count: 0
                };
          if (statusToGetData) {
            const filtersToSend = { ...filters };
            if (filtersToSend.arrival_date && filtersToSend.completed_date) {
              filtersToSend.arrival_date = [
                filters.arrival_date,
                filters.completed_date
              ];
              delete filtersToSend.completed_date;
            }
            const payload = {
              filtered: { ...filtersToSend, request_status: [statusToGetData] },
              pageSize,
              page: 0
            };
            const { supportTickets, count, missingItems } =
              await actions.loadSupportTickets(payload);
            result = {
              ...availableStatus,
              tickets: orderBy(
                supportTickets,
                [(ticket) => new Date(ticket.modified_on)],
                "desc"
              ),
              pages: Math.ceil(count / pageSize),
              count,
              missingItems
            };
          }
          return result;
        })
      );
      setTimeout(
        () => actions.setSupportTicketsBoardReducer(newSupportTicketsBoard),
        2000
      );
      return false;
    } catch (error) {
      toast.error(error.message);
    } finally {
      this.setState({ loading: false });
    }
  };

  generateCodeOptions = (entity, field) => {
    const codeOptions = this.props.codes
      .filter((codes) => codes.entity === entity && codes.field === field)
      .map((code) => ({
        value: code._id,
        label: code.label,
        order: code.order
      }));
    return orderBy(
      codeOptions,
      [(option) => option.label.toLowerCase()],
      "order"
    );
  };

  loadMoreSupportTicketsBoard = async (e, name) => {
    try {
      this.setState({ loading: true });
      e.preventDefault();
      e.stopPropagation();
      const { supportTicketsBoard, actions } = this.props;
      const { defaultPageSize: pageSize, filters } = this.state;

      const allStatus = this.generateCodeOptions("Support Ticket", "status");
      const statusToGetData = allStatus.find(
        (rStatus) => rStatus.label === name
      );
      const { page } = supportTicketsBoard.find(
        (availableStatus) => availableStatus.label === name
      );
      const payload = {
        filtered: { ...filters, request_status: [statusToGetData] },
        pageSize,
        page: page + 1
      };
      const { supportTickets, missingItems } =
        await actions.loadSupportTickets(payload);
      actions.setSupportTicketsBoardReducer(
        supportTicketsBoard.map((supportTicketBoard) =>
          supportTicketBoard.label === name
            ? {
                ...supportTicketBoard,
                tickets: [
                  ...supportTicketBoard.tickets,
                  ...orderBy(
                    supportTickets,
                    [(ticket) => new Date(ticket.modified_on)],
                    "desc"
                  )
                ],
                page: page + 1,
                missingItems
              }
            : supportTicketBoard
        )
      );
    } catch (error) {
      toast.error(error.message);
    } finally {
      this.setState({ loading: false });
    }
  };

  fetchTickets = async (state) => {
    this.setState({ loading: true });
    let { search } = this.state;
    const { pageSize, page, sorted, filtered, columns } = state;

    if (search) {
      search = columns
        .filter(
          (col) =>
            col.Header &&
            [
              "Ticket Number",
              "Priority",
              "Customer",
              "Request Nature"
            ].includes(col.Header)
        )
        .map((col) => ({ id: col.accessor, value: search }));
    }
    const filters = { ...filtered };
    if (filters.arrival_date && filters.completed_date) {
      filters.arrival_date = [filters.arrival_date, filters.completed_date];
      delete filters.completed_date;
    }
    const payload = {
      pageSize,
      page,
      sorted,
      filtered: filters,
      search
    };
    if (this.state.viewDisplay) {
      this.getTicketsBoard();
    } else {
      const { supportTickets, count } =
        await this.props.actions.loadSupportTickets(payload);
      this.setState({
        supportTickets,
        count,
        pages: Math.ceil(count / pageSize)
      });
    }
    this.setState({ loading: false });
  };

  handleChangeDate = (startDate, endDate) => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          ...(startDate && { arrival_date: moment(startDate).startOf("day") }),
          ...(endDate && { completed_date: moment(endDate).endOf("day") })
        }
      },
      () => {
        localStorage.setItem(
          "ticket-filters",
          JSON.stringify(this.state.filters)
        );
        if (this.state.viewDisplay) {
          this.getTicketsBoard();
        }
      }
    );
  };

  handleClickView = (ticket) => {
    const pushTo = !ticket.is_assigned
      ? `/app/support-tickets/add/${ticket._id}`
      : `/app/support-tickets/${ticket._id}`;

    this.props.history.push(pushTo);
  };

  handleChangeFilters = (field, value) => {
    const { filters } = this.state;
    this.setState({ loading: true });
    if (field === "request_status") {
      filters.request_status = value || [];
      const notInProcessFilter = filters.request_status?.find(
        (status) => status.label !== "In Process"
      );
      if (notInProcessFilter || !filters.request_status?.length) {
        delete filters.response_due;
      }
    }
    if (field === "assigned_department") {
      // get department users for multi_assigned_to options
      const users = [];
      for (let i = 0; i < value.length; i += 1) {
        this.props.users.forEach((user) => {
          if (user.department._id === value[i].value) {
            users.push(user);
          }
        });
      }
      filters.assigned_department = value;
      this.setState({ users });
      // filter by users in selected department(s)
      const departmentUsers = users.map((user) => ({
        value: user._id,
        label: user.full_name
      }));
      if (!filters.multi_assigned_to.length) {
        filters.departmentUsers = departmentUsers;
      }
    }
    if (field === "multi_assigned_to") {
      // get user departments for assigned_department filter
      const userIds = value.map((val) => val.value);
      const users = this.props.users.filter((user) =>
        userIds.includes(user._id)
      );
      const departmentIds = users.map((user) => user.department._id);
      const departmentFilters = this.props.departments
        .filter((department) => departmentIds.includes(department._id))
        .map((department) => ({
          value: department._id,
          label: department.description
        }));
      filters.multi_assigned_to = value;
      filters.assigned_department = departmentFilters;
      if (filters.multi_assigned_to.length) {
        filters.departmentUsers = [];
      }
    }
    if (field === "customer") {
      filters.customer = value;
    }
    if (field === "response_due") {
      const notInProcessFilter = filters.request_status?.find(
        (status) => status.label !== "In Process"
      );
      if (notInProcessFilter || !filters.request_status?.length) {
        const { codes } = this.props;
        const inProcessStatus = codes.find(
          (c) => c.label === "In Process" && c.entity === "Support Ticket"
        );
        filters.request_status = [
          { value: inProcessStatus?._id, label: "In Process" }
        ];
      }
      filters.response_due = value;
    }
    if (field === "location") {
      filters.location = value.value;
    }
    if (this.state.viewDisplay) {
      this.getTicketsBoard();
    }
    this.setState({ filters: { ...filters } }, () => {
      localStorage.setItem(
        "ticket-filters",
        JSON.stringify(this.state.filters)
      );
    });
    this.setState({ loading: false });
  };

  resetFilters = () => {
    const { codes } = this.props;
    const inProcessStatus = codes.find(
      (c) => c.label === "In Process" && c.entity === "Support Ticket"
    );
    this.setState(
      {
        users: this.props.users,
        filters: {
          request_status: [
            { value: inProcessStatus?._id, label: "In Process" }
          ],
          customer: [],
          assigned_department: [],
          multi_assigned_to: [],
          location: ""
        }
      },
      () => {
        if (this.state.viewDisplay) this.getTicketsBoard();
      }
    );
    localStorage.removeItem("ticket-filters");
    this.setState({ loading: false });
  };

  filter = (e) => {
    this.setState({
      loading: true,
      search: e.target.value,
      filters: { ...this.state.filters }
    });
    this.setState({ loading: false });
  };

  generateTicketStatus = () => {
    const codeOptions = this.props.codes.filter(
      (code) => code.entity === "Support Ticket" && code.field === "status"
    );
    return codeOptions;
  };

  isMovementAllowed = (source, destination) => {
    const sourcePosition = Object.keys(this.ticketMovementsAllowed).find(
      (key) => Number(key) === Number(source)
    );
    return this.ticketMovementsAllowed[sourcePosition].includes(destination);
  };

  handleDragEnd = async (result) => {
    const ticketsToFind = this.props.supportTicketsBoard.find(
      (tickets) => tickets.label === result.source.droppableId
    );
    const ticket = ticketsToFind.tickets.find(
      (dt) => dt._id === result.draggableId
    );

    const states = this.generateTicketStatus();
    const destination = states.find(
      (state) => state.label === result.destination.droppableId
    );
    const source = states.find(
      (state) => state.label === result.source.droppableId
    );
    if (this.isMovementAllowed(source.order, destination.order)) {
      this.setState({ source, destination, ticket }, () => {
        this.performLocalMove();
        this.onTicketMove(source.order, destination.order);
      });
    } else {
      toast.error("Movement not allowed");
    }
  };

  onTicketMove = (sourceOrder, destinationOrder) => {
    if (sourceOrder === 1 && destinationOrder === 3) {
      this.props.actions.showModal("holdTicketModal");
    } else if (
      (sourceOrder === 2 || sourceOrder === 3) &&
      destinationOrder === 1
    ) {
      this.handleReopen();
    } else if (
      (sourceOrder === 1 || sourceOrder === 3) &&
      destinationOrder === 2
    ) {
      this.handleResolve();
    } else if (sourceOrder === 0 && destinationOrder === 1) {
      this.handleAssign();
    }
  };

  handleAssign = async () => {
    const { calls } = await this.props.actions.loadCalls({
      isPopulated: true,
      filtered: { support_ticket_id: [this.state.ticket._id] }
    });
    const lastCall = calls[calls.length - 1];
    this.setState({ lastCall });
    this.props.actions.getSupportTicketSuccess(this.state.ticket);
    this.props.actions.showModalSuccess("supportTicketModal");
  };

  onAssign = async (call) => {
    const { auth, contracts, supportTicket } = this.props;

    const contract = contracts?.find((item) => item._id === call.contract);

    await this.props.actions.createCall(call);

    this.onCloseModal();

    const updatedSupportTicket = {
      ...supportTicket,
      id: this.state.ticket._id,
      assigned_to: call.assigned_to,
      is_assigned: true,
      customer: call.customer,
      assigned_by: auth.user._id,
      entered_on: formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
      request_status: this.state.destination._id,
      modified_by_user_id: auth.user._id,
      project: call.project,
      tier: contract?.tier
    };

    const updatedTicket =
      await this.props.actions.updateSupportTicket(updatedSupportTicket);

    if (updatedTicket.showPrompt) {
      const customer = this.props.customers.find(
        (c) => c._id === call.customer
      );
      this.setState({
        callToSave: { ...call, customer },
        requestor_company_name: this.props.supportTicket.requestor_company_name
      });
      this.props.actions.showModalSuccess("addAltNameModal");
    } else {
      if (updatedTicket.altNameInUse) {
        toast.warning(
          `${updatedTicket.altNameInUse.requestor_company_name} is an alternative name for ${updatedTicket.altNameInUse.customer}. See Alternative Names page.`,
          8000
        );
      }
      if (updatedTicket.showProjectPrompt && auth.maxRole >= 4000) {
        const project = this.props.projects.find((p) => p._id === call.project);
        this.setState({
          callToSave: { ...call, project }
        });
        this.props.actions.showModalSuccess("projectKeywordsModal");
      } else {
        this.performFinalMove();
      }
    }
  };

  handleAddAlternativeNameConfirm = async () => {
    this.props.actions.hideModal("addAltNameModal");
    const customer = this.props.customers.find(
      (c) => c._id === this.state.callToSave.customer._id
    );
    await this.props.actions.updateCustomer({
      ...customer,
      id: customer._id,
      alternative_names: customer.alternative_names
        ? [...customer.alternative_names, this.state.requestor_company_name]
        : [this.state.requestor_company_name]
    });
    this.performFinalMove();
  };

  handleAddAlternativeNameCancel = async () => {
    this.props.actions.hideModal("addAltNameModal");
    this.performFinalMove();
  };

  handleAddProjectKeywordsConfirm = async () => {
    this.props.actions.hideModal("projectKeywordsModal");
    this.props.history.push(
      `/app/project-keywords?customer=${this.state.callToSave.customer}`
    );
  };

  handleAddProjectKeywordsCancel = async () => {
    this.props.actions.hideModal("projectKeywordsModal");
    this.performFinalMove();
  };

  handleHold = async () => {
    const { auth } = this.props;
    const data = {
      id: this.state.ticket._id,
      modified_by_user_id: auth.user._id,
      additional_note: this.state.note,
      request_status: this.state.destination._id,
      actionRequiredBy: this.state.actionRequiredBy?.value
    };
    await this.props.actions.updateSupportTicket(data);
    this.performFinalMove();
  };

  handleReopen = async () => {
    const { codes, auth } = this.props;
    const inProcessStatus = codes.find(
      (c) => c.label === "In Process" && c.entity === "Support Ticket"
    );
    const reOpenedStatus = codes.find(
      (c) => c.label === "ReOpened" && c.entity === "Support Ticket"
    );
    const data = {
      id: this.state.ticket._id,
      request_status: inProcessStatus._id,
      modified_by_user_id: auth.user._id
    };
    const newAuditLog = {
      note: "Ticket reopened",
      action: reOpenedStatus._id,
      user: auth.user._id
    };
    await this.props.actions.addAuditLog(data.id, newAuditLog);
    await this.props.actions.updateSupportTicket(data);
    this.performFinalMove();
  };

  handleResolve = async () => {
    const { calls } = await this.props.actions.loadCalls({
      isPopulated: true,
      filtered: { support_ticket_id: [this.state.ticket._id] }
    });

    const openCall = calls.find((call) => call.stage.order < 4);

    if (!openCall) {
      this.props.actions.showModalSuccess("resolveTicketModal");
    } else {
      this.props.actions.showModalSuccess("reviewOpenCallsModal");
    }
  };

  onResolve = async () => {
    const { auth } = this.props;

    const resolution = {
      resolved_by: auth.user._id,
      closing_note: this.state.note,
      resolved_on: new Date()
    };

    const data = {
      id: this.state.ticket._id,
      request_status: this.state.destination._id,
      resolution,
      modified_by_user_id: auth.user._id,
      additional_note: this.state.note,
      send_customer_email: this.state.sendCustomerEmail
    };
    await this.props.actions.updateSupportTicket(data);
    this.performFinalMove();
  };

  handleTicketClick = (ticket) => {
    this.props.actions.getSupportTicketModal(
      ticket._id,
      "customerSupportTicketDetailsModal"
    );
  };

  onReviewOpenCalls = () => {
    this.props.history.push(`/app/support-tickets/${this.state.ticket._id}`);
  };

  performLocalMove = () => {
    const { source, destination, ticket, supportTickets, viewDisplay } =
      this.state;
    const { supportTicketsBoard, actions } = this.props;
    const ticketUpdated = { ...ticket, request_status: destination };
    if (!viewDisplay) {
      const newLocalTickets = supportTickets.map((_ticket) =>
        _ticket._id === ticket._id ? ticketUpdated : _ticket
      );

      this.setState({
        supportTickets: newLocalTickets
      });
    } else {
      const newSupportTicketsBoard = supportTicketsBoard.map(
        (supportTicketBoard) => {
          if (source.label === supportTicketBoard.label) {
            return {
              ...supportTicketBoard,
              tickets: supportTicketBoard.tickets.filter(
                (supportTicket) => supportTicket._id !== ticket._id
              )
            };
          }
          if (destination.label === supportTicketBoard.label) {
            return {
              ...supportTicketBoard,
              tickets: [ticketUpdated, ...supportTicketBoard.tickets]
            };
          }
          return supportTicketBoard;
        }
      );
      actions.setSupportTicketsBoardReducer(newSupportTicketsBoard);
    }
  };

  performFinalMove = () => {
    const {
      viewDisplay,
      defaultPageSize: pageSize,
      filters: filtered
    } = this.state;
    if (!viewDisplay) {
      this.fetchTickets({
        pageSize,
        page: 0,
        sorted: [],
        filtered,
        columns: []
      });
    }

    this.setState({
      note: "",
      ticket: {},
      source: {},
      destination: {}
    });
  };

  handleInput = (e) => {
    const { value } = e.target;
    this.setState({ note: value });
  };

  handleCheckbox = (e) => {
    this.setState({ sendCustomerEmail: e?.target?.checked });
  };

  onCloseModal = (id, wasCanceled) => {
    this.setState({ note: "" });
    this.props.actions.hideModal();
    if (wasCanceled) {
      const { source, destination, ticket, viewDisplay } = this.state;
      if (viewDisplay) {
        const ticketUpdated = { ...ticket, request_status: source };
        const newSupportTicketsBoard = this.props.supportTicketsBoard.map(
          (supportTicketBoard) => {
            if (destination.label === supportTicketBoard.label) {
              return {
                ...supportTicketBoard,
                tickets: supportTicketBoard.tickets.filter(
                  (supportTicket) => supportTicket._id !== ticket._id
                )
              };
            }
            if (source.label === supportTicketBoard.label) {
              return {
                ...supportTicketBoard,
                tickets: [ticketUpdated, ...supportTicketBoard.tickets]
              };
            }
            return supportTicketBoard;
          }
        );
        this.props.actions.setSupportTicketsBoardReducer(
          newSupportTicketsBoard
        );
      } else {
        this.performFinalMove();
      }
    }
  };

  onCloseCreateNewTicketModal = () => {
    this.props.actions.hideModal();
    this.fetchTickets({
      pageSize: this.state.defaultPageSize,
      page: 0,
      sorted: [],
      filtered: this.state.filters,
      columns: []
    });
  };

  onViewTicketClick = () => {
    const { supportTicket } = this.props;
    this.props.history.push(
      `/app/support-tickets/${supportTicket?.supportTicket._id}`
    );
  };

  onChangePriorityClick = (priority) => {
    if (this.props.supportTicket.request_priority !== priority) {
      this.setState({ selectedPriority: priority });
      this.props.actions.showModalSuccess("priorityModal");
    }
  };

  handleChangePriority = async () => {
    const { supportTicket, auth, codes } = this.props;
    const data = {
      ...supportTicket,
      request_priority: this.state.selectedPriority,
      request_status: supportTicket.request_status._id
    };
    await this.props.actions.updateSupportTicket(data);

    const up_code = find(codes, {
      entity: "Support Ticket",
      value: "UP"
    });

    const auditLogData = {
      user: auth.user._id,
      action: up_code?._id,
      note: `${auth.user.full_name} updated the request priority from ${supportTicket.request_priority} to ${this.state.selectedPriority}. ${this.state.note}`
    };

    await this.props.actions.addAuditLog(supportTicket._id, auditLogData);

    // i need see if this is required here
    // if (this.state.viewDisplay) {
    //   this.getTicketsBoard();
    // } else {
    this.fetchTickets({
      pageSize: this.state.defaultPageSize,
      page: 0,
      sorted: [],
      filtered: this.state.filters,
      columns: []
    });
  };

  render() {
    const {
      isMobile,
      actions,
      customers,
      contracts,
      projects,
      auth,
      codes,
      savingCall,
      supportTicket,
      supportTicketsBoard
    } = this.props;
    const {
      supportTickets,
      filters,
      count,
      pages,
      open,
      users,
      defaultPageSize,
      lastCall
    } = this.state;
    const ModalBody = () => (
      <div
        className="modal__form__body"
        style={{
          background: "white",
          margin: 0,
          padding: 30,
          overflow: "scroll"
        }}
      >
        <JotformEmbed src={`${jotFormUrl}${jotFormKey}`} />
      </div>
    );

    const getClassName = (request_priority) => {
      if (request_priority === "Normal") {
        return "warning";
      }
      if (request_priority === "High") {
        return "danger";
      }
      return "success";
    };

    const className = getClassName(supportTicket?.request_priority);

    const changePriorityForm = (
      <div>
        <p>
          Would you like to update this ticket to priority{" "}
          {this.state.selectedPriority}?
        </p>
        <textarea
          maxLength="250"
          className={
            auth.isNightMode ? "form-control-dark" : "form-control-light"
          }
          onChange={this.handleInput}
          placeholder="Note"
        />
        <small
          style={{
            float: "right",
            color: this.state.note && this.state.note.length >= 250 ? "red" : ""
          }}
        >
          {this.state.note ? `${this.state.note.length} / ` : ""}250 Character
          Limit
        </small>
      </div>
    );

    const supportTicketForm = (
      <React.Fragment>
        <h3
          style={{ marginTop: 0 }}
        >{`Support Ticket #${supportTicket?.supportTicket?.support_ticket_number}`}</h3>

        {supportTicket?.supportTicket?.request_priority && (
          <div
            className="dropdown-on-header"
            style={{ display: "inline-block" }}
          >
            <DropdownButton
              id="priorities-dropdown"
              className={`no-default btn-${className}`}
              style={{ marginTop: 0 }}
              title={supportTicket?.supportTicket?.request_priority}
            >
              <NavItem
                active={
                  supportTicket?.supportTicket?.request_priority === "Low"
                }
                onClick={() => this.onChangePriorityClick("Low")}
              >
                Low
              </NavItem>
              <NavItem
                active={
                  supportTicket?.supportTicket?.request_priority === "Normal"
                }
                onClick={() => this.onChangePriorityClick("Normal")}
              >
                Normal
              </NavItem>
              <NavItem
                active={
                  supportTicket?.supportTicket?.request_priority === "High"
                }
                onClick={() => this.onChangePriorityClick("High")}
              >
                High
              </NavItem>
            </DropdownButton>
          </div>
        )}
        {supportTicket?.supportTicket?.request_status && !isMobile && (
          <Badge color={supportTicket?.supportTicket?.request_status?.color}>
            {supportTicket?.supportTicket.request_status?.label}
          </Badge>
        )}
        <div style={{ marginTop: "1rem", background: "#F5F6FA" }}>
          <SupportTicketDisplay
            supportTicket={supportTicket?.supportTicket}
            open={this.state.open}
          />
        </div>
        <div className="modal-footer">
          <button
            className="btn btn-success"
            type="button"
            onClick={this.onViewTicketClick}
          >
            View Ticket
          </button>

          <button
            className="btn btn-default"
            type="button"
            onClick={actions.hideModal}
          >
            Close
          </button>
        </div>
      </React.Fragment>
    );

    const holdModalForm = (
      <div style={{ minHeight: "25rem" }}>
        <p>
          Enter a reason for placing ticket on Hold. This note will be sent to
          the customer.
        </p>
        <div className="hold-modal-wrapper">
          <textarea
            maxLength="250"
            className="form-control"
            onChange={this.handleInput}
            placeholder="Note"
          />
          <small
            style={{
              float: "right",
              color:
                this.state.note && this.state.note.length >= 250 ? "red" : ""
            }}
          >
            {this.state.note ? `${this.state.note.length} / ` : ""}250 Character
            Limit
          </small>
        </div>
        <Select
          fullwidth
          className="react-select-container"
          classNamePrefix="react-select-container"
          placeholder="Action Required By"
          value={this.state.actionRequiredBy}
          options={[
            { label: "Gravoc", value: "Gravoc" },
            { label: "Customer", value: "Customer" }
          ]}
          onChange={(e) => {
            this.setState({ actionRequiredBy: e });
          }}
        />
      </div>
    );

    const confirmClose = (
      <div>
        <p>Are you sure you want to resolve this ticket?</p>
        <textarea
          maxLength="250"
          className="form-control"
          onChange={this.handleInput}
          placeholder="Note"
        />
        <small
          style={{
            float: "right",
            color: this.state.note && this.state.note.length >= 250 ? "red" : ""
          }}
        >
          {this.state.note ? `${this.state.note.length} / ` : ""}250 Character
          Limit
        </small>
        <div
          style={{ display: "flex", alignItems: "center", marginTop: "2rem" }}
        >
          <Checkbox
            name="sendCustomerEmail"
            checked={this?.state?.sendCustomerEmail}
            onClickCheck={this.handleCheckbox}
          />
          <div style={{ marginLeft: "1rem" }}>
            Send Customer Email
            <small style={{ marginLeft: "1rem" }}>
              *This includes the resolution note above.
            </small>
          </div>
        </div>
      </div>
    );

    const assignForm = (
      <SupportTicketForm
        supportTicket={supportTicket}
        customers={customers}
        contracts={contracts}
        projects={projects}
        users={users}
        call={lastCall}
        auth={auth}
        codes={codes}
        saving={savingCall}
        onSave={this.onAssign}
        onCancel={() => this.onCloseModal("supportTicketModal", true)}
        callDefaultCustomer
        callDefaultProject
        callDefaultAssignedTo
      />
    );
    return (
      <React.Fragment>
        <HeaderWrapper
          classNames="tickets-header"
          breadcrumbs={[{ label: "Support Tickets" }]}
          onClickEdit={this.handleEdit}
          isMobile={isMobile}
          icon={<Badge className="round">{count}</Badge>}
          onFilter={this.filter}
          loading={this.state.loading}
          onClickAction={[
            {
              action: () => this.setState({ open: !open }),
              icon: <IoFunnel />
            },
            {
              action: () => actions.showModal("supportTicketEntryModal"),
              className: "btn-success",
              text: "Add"
            }
          ]}
          onToggle={
            auth.maxRole >= 5000 &&
            !isMobile &&
            ((checked) =>
              this.setState(
                {
                  viewDisplay: checked
                },
                () => {
                  localStorage.setItem("tickets-view", this.state.viewDisplay);
                  if (this.state.viewDisplay) {
                    this.getTicketsBoard();
                  } else {
                    this.fetchTickets({
                      pageSize: this.state.defaultPageSize,
                      page: 0,
                      sorted: [],
                      filtered: this.state.filters,
                      columns: []
                    });
                  }
                }
              ))
          }
          viewDisplay={this.state.viewDisplay}
        />
        <Row style={{ margin: 0 }}>
          <Col md={12}>
            <FiltersComponent
              open={open}
              filters={filters}
              focusedInput={this.state.focusedInput}
              onChangeFilters={this.handleChangeFilters}
              onChangeDate={this.handleChangeDate}
              onFocusChange={(focusedInput) => this.setState({ focusedInput })}
              onReset={this.resetFilters}
              fields={[
                "Ticket Status",
                "Multi Assigned To",
                "Assigned Department",
                "Assigned Customer",
                "Date",
                "Location",
                "ResponseDue"
              ]}
              isTicketFilters
              filteredUsers={users}
              loading={this.state.loading}
            />
          </Col>
        </Row>

        {this.state.viewDisplay && !isMobile ? (
          <div className="content-wrapper">
            <SupportTicketBoard
              isCombineEnabled
              loadMoreSupportTicketsBoard={this.loadMoreSupportTicketsBoard}
              auth={this.props.auth}
              supportTicketsBoard={supportTicketsBoard}
              loading={this.state.loading}
              onDragEnd={this.handleDragEnd}
              onTicketClick={this.handleTicketClick}
            />
          </div>
        ) : (
          <div className="content-wrapper">
            <SupportTicketList
              serverSide
              auth={this.props.auth}
              ref={(i) => (this.list = i)}
              fetchData={this.fetchTickets}
              data={supportTickets}
              pages={pages}
              filtered={filters}
              isMobile={isMobile}
              loading={this.state.loading}
              onClickView={this.handleClickView}
              defaultPageSize={defaultPageSize}
              onPageSizeChange={this.onPageSizeChange}
            />
          </div>
        )}
        <Modal
          id="supportTicketEntryModal"
          title="Create Ticket"
          body={<ModalBody />}
          close={this.onCloseCreateNewTicketModal}
          closeOnClick={false}
          keyboard={false}
          headerClassNames="ticket-modal-header"
        />
        <Modal
          id="supportTicketModal"
          title="Assign Ticket"
          body={assignForm}
          close={this.onCloseModal}
        />
        <ConfirmModal
          id="holdTicketModal"
          title="Place Ticket On Hold"
          confirmLabel="Hold"
          disabled={!this.state.note || !this.state.actionRequiredBy}
          body={holdModalForm}
          confirm={this.handleHold}
          close={this.onCloseModal}
        />
        <ConfirmModal
          id="resolveTicketModal"
          title="Resolve Ticket"
          body={confirmClose}
          disabled={!this.state.note}
          confirm={this.onResolve}
          close={this.onCloseModal}
        />
        <ConfirmModal
          id="reviewOpenCallsModal"
          title="Review Open Calls"
          body={
            <div>
              There are open calls associated with this ticket. Please review
              open calls before resolving.
            </div>
          }
          confirm={this.onReviewOpenCalls}
          close={this.onCloseModal}
        />
        <Modal
          id="customerSupportTicketDetailsModal"
          body={supportTicketForm}
          showHeader={false}
        />
        <ConfirmModal
          id="priorityModal"
          title="Change Priority"
          body={changePriorityForm}
          close={this.props.actions.hideModal}
          confirm={this.handleChangePriority}
          disabled={!this.state.note}
        />
        <ConfirmModal
          id="addAltNameModal"
          title="Add Alternative Customer Name"
          confirmLabel="Add"
          cancelLabel="Don't Add"
          body={
            <div>
              Would you like to add{" "}
              <b>{this.props.supportTicket.requestor_company_name}</b> as an
              alternative customer name for{" "}
              <b>{this.state.callToSave?.customer.name}</b>
            </div>
          }
          confirm={this.handleAddAlternativeNameConfirm}
          close={this.handleAddAlternativeNameCancel}
        />
        <ConfirmModal
          id="projectKeywordsModal"
          title="Add Project Keywords"
          confirmLabel="Visit Page"
          cancelLabel="No"
          body={
            <div>
              Would you like to add keywords to{" "}
              <b>{this.state.callToSave?.project?.name}</b> to help select this
              project for future tickets
            </div>
          }
          confirm={this.handleAddProjectKeywordsConfirm}
          close={this.handleAddProjectKeywordsCancel}
        />
      </React.Fragment>
    );
  }
}

const TicketFilters = ({ onChangeFilters }) => (
  <FilterStyles>
    <Col md={4}>
      <FormGroup>
        <Checkbox label="Open" value="O" onClickCheck={onChangeFilters} />
        <Checkbox label="Closed" value="R" onClickCheck={onChangeFilters} />
        <Checkbox label="Assigned" value="A" onClickCheck={onChangeFilters} />
        <Checkbox label="My Tickets" onClickCheck={onChangeFilters} />
      </FormGroup>
    </Col>
  </FilterStyles>
);
TicketFilters.propTypes = {
  onChangeFilters: PropTypes.func
};
const FilterStyles = styled(Row)`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.light_grey};
  padding: 10px 0 20px 0;
  .form-group {
    display: grid;
    align-items: center;
    grid-gap: 40px;
    grid-template-columns: repeat(4, auto);
    margin: 0 !important;
    & > label {
      margin: 0 !important;
      white-space: nowrap;
      width: auto !important;
    }
  }
  .DateRangePicker {
    margin: 0 !important;
  }
`;

SupportTicketPage.propTypes = {
  actions: PropTypes.object,
  auth: PropTypes.object,
  departments: PropTypes.array,
  isMobile: PropTypes.bool,
  history: PropTypes.object,
  users: PropTypes.array,
  customers: PropTypes.array,
  codes: PropTypes.array,
  projects: PropTypes.array,
  contracts: PropTypes.array,
  savingCall: PropTypes.bool,
  supportTicket: PropTypes.object,
  supportTicketsBoard: PropTypes.array
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth,
    codes: state.reducers.codes,
    users: state.reducers.users,
    departments: state.reducers.departments,
    customers: state.reducers.customers,
    projects: state.reducers.projects,
    contracts: state.reducers.contracts,
    savingCall: state.reducers.savingCall,
    supportTicket: state.reducers.supportTicket,
    supportTicketsBoard: state.reducers.supportTicketsBoard
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...supportTicketActions,
        ...callActions,
        ...codeActions,
        ...userActions,
        ...departmentActions,
        ...customerActions,
        ...modalActions,
        ...contractActions,
        ...projectActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(SupportTicketPage);
